import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'antd'

import "./stylesheets/index.scss"

// 动态判断内容是否超出宽度，超出则展示tooltip
function AdaptiveTooltip(props) {
  const [isShowTooltip, setIsShowTooltip] = useState(false)
  let dom = useRef();

  useEffect(() => {
    if (dom && dom.current) {
      const clientWidth = dom.current.clientWidth;
      const scrollWidth = dom.current.scrollWidth;
      setIsShowTooltip(clientWidth < scrollWidth)
    }
  }, [])

  const { className: cls, children, ...restProps } = props;

  if (!isShowTooltip) {
    return <div ref={dom} className={`AdaptiveTooltip--basic ${cls}`} {...restProps}>
      {children}
    </div>
  }

  return <Tooltip className={`AdaptiveTooltip--basic ${cls}`} {...restProps}>
    {children}
  </Tooltip>
}

export default AdaptiveTooltip


// WEBPACK FOOTER //
// ./src/components/AdaptiveTooltip/index.js